export const outbrainModule = {
  name: 'Outbrain',
};
